import React from 'react';
import {IconCrosshair} from '../Icons';

const GeolocationButton = ({handleClick}) => {
    return(
        <button
            type="button"
            onClick={ () => getLocation(handleClick) }>
            <IconCrosshair />
        </button>
    );
};

const getLocation = callback => {
    // onClick let input know that value is loading
    callback({
        loading: true,
        error: false,
        coords: {}
    });

    window.navigator.geolocation.getCurrentPosition(
        (res) => {
            callback({
                loading: false,
                error: false,
                coords: {
                    lat: res.coords.latitude,
                    lng: res.coords.longitude
                }
            });
        },
        () => {
            callback({
                error: {
                    msg: 'Geolocation not available in your browser. Please try typing out your location.',
                    severity: 'error'
                },
                loading: false,
                coords: {}
            });
        },
        { timeout: 8000 }
    );
};

export default GeolocationButton;